import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Button, Heading, Text } from '@frontend/design-system';
import { MetricSection } from './call-quality-components';
import { MosChartSection, OverviewSection } from './call-quality-drilldown-components';
import { PanelHeader } from './common';
import { SCREENS } from './const';
import { ScreenBase, MetricData } from './types';

export const CallQualityDrilldownScreen = ({ setScreen }: ScreenBase) => {
  const { t } = useTranslation('calls');

  const data: MetricData[] = [
    {
      type: 'mosAvg',
      values: [{ sentiment: 'warn', label: '3.5/5' }],
    },
    {
      type: 'packetLossAvg',
      values: [
        { sentiment: 'negative', direction: 'inbound', label: '4%' },
        { sentiment: 'negative', direction: 'outbound', label: '5%' },
      ],
    },
    {
      type: 'jitterAvg',
      values: [
        { sentiment: 'warn', direction: 'inbound', label: '21 ms' },
        { sentiment: 'warn', direction: 'outbound', label: '16 ms' },
      ],
    },
  ];

  return (
    <div>
      <PanelHeader setScreen={setScreen}>
        <div
          style={{
            display: 'grid',
            alignItems: 'center',
            columnGap: theme.spacing(1),
            gridTemplateColumns: 'auto 1fr',
            gridTemplateAreas: '"back title" ". label"',
          }}
        >
          <Button
            iconName='caret-left'
            variant='secondary'
            css={{ gridArea: 'back' }}
            onClick={() => {
              setScreen(SCREENS.CALL_QUALITY);
            }}
          />
          <Heading level={2} css={{ margin: 0, gridArea: 'title' }}>
            {t('Low Quality Interval')}
          </Heading>
          <Text css={{ gridArea: 'label' }} as='span' size='medium'>
            8:17:25 AM - 8:18:45 AM
          </Text>
        </div>
      </PanelHeader>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(auto-fit, auto)',
          padding: theme.spacing(3),
          gap: theme.spacing(2),
        }}
      >
        <OverviewSection />
        <div css={{ borderTop: `1px solid ${theme.colors.neutral20}` }} />
        <MetricSection
          subtitle={
            <div>
              <Text size='medium' color='light'>
                {'8:17:25 AM - 8:18:45 AM'}
              </Text>
              <Text size='medium' color='light'>
                {t('Averages are calculated from the events in this low-quality interval.')}
              </Text>
            </div>
          }
          data={data}
        />
        <div css={{ borderTop: `1px solid ${theme.colors.neutral20}` }} />
        <MosChartSection />
      </div>
    </div>
  );
};
